import { Link } from "@flat-ui";
import { useAppNavigation } from "@hooks/use-app-navigation";
import { Box } from "@mui-wrapper";

/** Renders a link to navigate to the login page from signup flows */
export function SignupLoginLink(): JSX.Element {
  const { navigateToLogin } = useAppNavigation();

  return (
    <Box
      sx={{
        width: "100%",
        marginTop: "10px",
        marginBottom: "40px",
        fontSize: "14px",
        color: "text.secondary",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      Already a member?
      <Link
        component="button"
        underline="none"
        onClick={navigateToLogin}
        sx={{ marginLeft: "5px" }}
      >
        Log in
      </Link>
    </Box>
  );
}
